import { useState, useEffect, useMemo } from "react";
// react-router components
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import axios from "axios";
// @mui material components
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import getFilteredRoutes from "utils/getFilteredRoutes";
// Material Dashboard 2 React example components
import Sidenav from "examples/Sidenav";
import Configurator from "examples/Configurator";

// Material Dashboard 2 React themes
import theme from "assets/theme";
import themeRTL from "assets/theme/theme-rtl";

// Material Dashboard 2 React Dark Mode themes
import themeDark from "assets/theme-dark";
import themeDarkRTL from "assets/theme-dark/theme-rtl";

// RTL plugins
import rtlPlugin from "stylis-plugin-rtl";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import Client from "admin/Setup/Client";
import Staff from "admin/Hr/Staff";
import Setup from "admin/Setup";
// Material Dashboard 2 React routes
// import routes from "routes";
// const filteredRoutes = await getFilteredRoutes();
// Material Dashboard 2 React contexts
import { useMaterialUIController, setMiniSidenav, setOpenConfigurator } from "context";

// Images
import brandWhite from "assets/images/logo-ct.png";
import brandDark from "assets/images/logo-ct-dark.png";
import ProtectedRoute from "components/ProtectedRoute";
export default function App() {
  const [filteredRoutes, setFilteredRoutes] = useState([]);
  const location = useLocation();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const guidToken = params.get("guidtoken");
    const landingPage = params.get("landingpage");
    const logoUrl = params.get("logourl");
    if (guidToken) {
      localStorage.setItem("landingPage", landingPage);
    }
    if (guidToken) {
      localStorage.setItem("logoUrl", logoUrl);
    }
    if (guidToken) {
      localStorage.setItem("guidtoken", guidToken);
      //window.history.replaceState({}, "", window.location.pathname);
    }
    const validateToken = async (landingPage, guidToken) => {
      const token = localStorage.getItem("guidtoken");
      if (!token) {
        window.location.href = localStorage.getItem("landingPage");
        return;
      }
      try {
        const res = await axios.post(`${API_BASE_URL}/bootstrap-guid.php?action=check-guidtoken`, {
          guidtoken: token,
        });
        if (!res.data.success) {
          const landingPage = localStorage.getItem("landingPage");
          window.location.href = landingPage;
        } else {
          const fetchRoutes = async () => {
            const routes = await getFilteredRoutes();
            setFilteredRoutes(routes);
          };
          fetchRoutes();
          //setLoading(false);
        }
      } catch (error) {
        //localStorage.removeItem("guidtoken");
        const landingPage = localStorage.getItem("landingPage");
        //window.location.href = landingPage;
      }
    };
    const gutoken = localStorage.getItem("guidtoken");
    if (gutoken != "" && gutoken != null) {
      validateToken(landingPage, guidToken);
      localStorage.removeItem("guidtoken");
    } else {
      localStorage.removeItem("guidtoken");
      localStorage.removeItem("landingPage");
      const fetchRoutes = async () => {
        const routes = await getFilteredRoutes();
        setFilteredRoutes(routes);
      };
      fetchRoutes();
    }
  }, [location.pathname]);
  const [controller, dispatch] = useMaterialUIController();
  const {
    miniSidenav,
    direction,
    layout,
    openConfigurator,
    sidenavColor,
    transparentSidenav,
    whiteSidenav,
    darkMode,
  } = controller;
  const [onMouseEnter, setOnMouseEnter] = useState(false);
  const [rtlCache, setRtlCache] = useState(null);
  const { pathname } = useLocation();
  const brandName = process.env.REACT_APP_BRAND_NAME;
  // Cache for the rtl
  useMemo(() => {
    const cacheRtl = createCache({
      key: "rtl",
      stylisPlugins: [rtlPlugin],
    });

    setRtlCache(cacheRtl);
  }, []);

  // Open sidenav when mouse enter on mini sidenav
  const handleOnMouseEnter = () => {
    if (miniSidenav && !onMouseEnter) {
      setMiniSidenav(dispatch, false);
      setOnMouseEnter(true);
    }
  };

  // Close sidenav when mouse leave mini sidenav
  const handleOnMouseLeave = () => {
    if (onMouseEnter) {
      setMiniSidenav(dispatch, true);
      setOnMouseEnter(false);
    }
  };
  // Change the openConfigurator state
  const handleConfiguratorOpen = () => setOpenConfigurator(dispatch, !openConfigurator);

  // Setting the dir attribute for the body element
  useEffect(() => {
    document.body.setAttribute("dir", direction);
    document.title = process.env.REACT_APP_BRAND_NAME;
  }, [direction]);
  // Setting page scroll to 0 when changing the route
  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  const getRoutes = (allRoutes) =>
    allRoutes.map((route) => {
      if (route.collapse) {
        return getRoutes(route.collapse);
      }
      if (route.route) {
        const isProtected = !route.route.startsWith("/authentication");
        return (
          <Route
            exact
            path={route.route}
            element={
              isProtected ? <ProtectedRoute>{route.component}</ProtectedRoute> : route.component
            }
            key={route.key}
          />
        );
      }
      return null;
    });
  const configsButton = (
    <MDBox
      display="flex"
      justifyContent="center"
      alignItems="center"
      width="3.25rem"
      height="3.25rem"
      bgColor="white"
      shadow="sm"
      borderRadius="50%"
      position="fixed"
      right="2rem"
      bottom="2rem"
      zIndex={99}
      color="dark"
      sx={{ cursor: "pointer" }}
      onClick={handleConfiguratorOpen}
    >
      <Icon fontSize="small" color="inherit">
        settings
      </Icon>
    </MDBox>
  );
  return direction === "rtl" ? (
    <CacheProvider value={rtlCache}>
      <ThemeProvider theme={darkMode ? themeDarkRTL : themeRTL}>
        <CssBaseline />
        {layout === "dashboard" && (
          <>
            <Sidenav
              color={sidenavColor}
              brand={(transparentSidenav && !darkMode) || whiteSidenav ? brandDark : brandWhite}
              brandName={brandName}
              routes={filteredRoutes}
              onMouseEnter={handleOnMouseEnter}
              onMouseLeave={handleOnMouseLeave}
            />
            <Configurator />
            {configsButton}
          </>
        )}
        {layout === "vr" && <Configurator />}
        <Routes>
          {getRoutes(filteredRoutes)}
          <Route path="*" element={<Navigate to="/dashboard" />} />
        </Routes>
      </ThemeProvider>
    </CacheProvider>
  ) : (
    <ThemeProvider theme={darkMode ? themeDark : theme}>
      <CssBaseline />
      {layout === "dashboard" && (
        <>
          <Sidenav
            color={sidenavColor}
            brand={(transparentSidenav && !darkMode) || whiteSidenav ? brandDark : brandWhite}
            brandName={brandName}
            routes={filteredRoutes}
            onMouseEnter={handleOnMouseEnter}
            onMouseLeave={handleOnMouseLeave}
          />
          <Configurator />
          {configsButton}
        </>
      )}
      {layout === "vr" && <Configurator />}
      <Routes>
        {getRoutes(filteredRoutes)}
        <Route path="*" element={<Navigate to="/dashboard" />} />
        <Route
          path="admin/setup/client"
          element={
            <ProtectedRoute>
              <Client />
            </ProtectedRoute>
          }
        />
        <Route
          path="admin/hr/staff"
          element={
            <ProtectedRoute>
              <Staff />
            </ProtectedRoute>
          }
        />
        <Route
          path="admin/setup"
          element={
            <ProtectedRoute>
              <Setup />
            </ProtectedRoute>
          }
        />
      </Routes>
    </ThemeProvider>
  );
}
